export class UserListEntity {
    UserListModel: User[];
    TotalRecord: number;
}

export class User {
    LoginId: number;
    CompanyId: number;
    Email: string;
    FirstName: string;
    LastName: string;
    DisplayName: string;
    Phone1: string;
    Phone2: string;
    UniquRefNo: string;
    Designation: string;
    Roles: string;
    IsActive: number;
    LastChangedBy: number;
    VendorId: number;
    Status: string;
    CountryName: string;
    PhotoPath: string;
    attachment: string;
    online: boolean;
}

export class UserLookupFilter {
    CompanyID: number;
    LoginId: number;
    VendorId: number;
    MaxRoleGroup: number;
    SortBy: string;
    OrderBy: string;
    StartRecord: number;
    EndRecord: number;
}
export class Users {
    LoginId: number;
}
export enum ShowPageEnum {
    RecentConvo = 0,
    ConvoMessage = 1,
    UsersList = 2,
    CreateNewGroup = 3,
    UserSettings = 4,
    UserProfile = 5
}
export class ConvoMessage {
    UserId: string;
    body: string;
    posted_at: Date;
    posted_atstr: string;
    username: string;
    type: number;
    group: string;
}
export class ThumbnailInput {
    fileName: string;
    LoginId: number;
    EmailId: string;
}
export class ThumbnailImage {
    fileName: string;
    filePath: string;
    attachment: string;
    LoginId: number;
    EmailId: string;
}